// cars/my-model
import { getData } from 'src/services/RestApi';
import { getCachedData } from 'src/utils/data-cache';
import { formatCode, formatDecimal } from 'src/utils/formatters';

const getMapping = () => {
  const keysMapping = getCachedData('keysMapping');
  const carTransmission = keysMapping?.carTransmission || {};
  const carType = keysMapping?.carType || {};
  const carStatus = keysMapping?.carStatus || {};

  return {carTransmission, carType, carStatus};
};

export const getCarList = async (
  payload,
  params,
  onEndPoint = () => {},
  onSuccess = () => {},
  onError = () => {},
) => {
  let endPoint = 'api/car/list';
  if(params){
    endPoint = `${endPoint}/${params}`;
  }
  onEndPoint(endPoint);

  const { result, error } = await getData(endPoint, payload);
  if (error) return onError(error);

  const hasGroup = payload?.keyword?.group?.trim();

  const { carTransmission, carType, carStatus } = getMapping();
  result.forEach(element => {
    element.transmission = carTransmission[element.transmission];
    element.carType = carType[element.carType];
    element.carStatus = carStatus[element.carStatus];

    if(element.fuelCard){
      element.fuelCard = formatCode(element.fuelCard, '-');
    }
    if(element.lastKm){
      element.lastKm = formatDecimal(element.lastKm);
    }
    element.options = hasGroup ? '' : element.groupName;
  });
  return onSuccess(result);
};

export const getCarAll = async (
  payload, {},
  onEndPoint = () => {},
  onSuccess = () => {},
  onError = () => {},
) => {
  let endPoint = 'api/car/all';
  onEndPoint(endPoint);

  const { result, error } = await getData(endPoint, payload);
  if (error) {
    return onError(error);
  }

  if (result) {
    const { carTransmission, carType, carStatus } = getMapping();

    result.forEach(element => {
      element.transmission = carTransmission[element.transmission];
      element.carType = carType[element.carType];
      element.carStatus = carStatus[element.carStatus];
    });
  }
  return onSuccess(result);
};

// Get car group assign (using get cars by group)
export const getCarGroupAssigned = async (payload) => {
  const { result, error } = await getData('api/car/group/assigned', { groups: payload });
  if(error) return [];
  return result;
};

export const getCarDetail = async (payload) => {
  const carId = Number(payload?.id) || 0;
  if (carId === 0) return {};

  const { result, error } = await getData('api/car/detail', { carId: payload.id });
  if(error) return {};
  
  if(result){
    const { carTransmission, carType } = getMapping();
    result.transmission = carTransmission[result.transmission];
    result.type = carType[result.type];
  }
  return result;
};

export const getCarRepairs = async (carId, params) => {
  let endPoint = 'api/car/repairs';
  if(params){
    endPoint = `${endPoint}/${params}`;
  }
  const { result, error } = await getData(endPoint, { carId: carId });
  
  return {result, error};
};
